import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Dcm from './DCM/Dcm';
import PatientInfo from './patient/PatientInfo';
import Report from './patient/Report';
import SummarizeIcon from '@mui/icons-material/Summarize';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import FeedIcon from '@mui/icons-material/Feed';
import { getSelectedPatientData } from "../service/api.service";
import { newSteps } from "./common/steps";
import "shepherd.js/dist/css/shepherd.css";
import { ShepherdTour, TourMethods } from "react-shepherd";
import Start from "./DCM/start";
import { clearLocalStrorage, getLocalstorage, setLocalstorage, tourOptions } from "./common/codeHelper";
import { EventEmitter } from "../event";
import PainSensitivityTab from "./patient/PainSensitivityTab";

import PainSensitivityResult from "./patient/PainSensitivityResult";
let activatePage = 0;
function ViewerTabs(props) {
    let location = useLocation();
    const navigate = useNavigate();
    // const params = useParams();
    const styleClasses = {
        tab: {
            color: '#1b2a47',
            fontWeight: 600,

        }
    }

    const [value, setValue] = useState(0);
    const [onboardingShow, setOnboardingShow] = useState(false);
    const [analysisData, setAnalysisData] = useState('');
    const handleChange = (event, newValue) => {
        setValue(newValue);
        activatePage = newValue;
    };

    const handleChangeTabs = (ev) => {
        if (ev === 'detail') {
            setValue(1);
            activatePage = 1;
        }
    }

    useEffect(() => {
        if (!analysisData) {
            getData();
            EventEmitter.subscribe("onBoardingChange", (event) => { 
                // console.log(event, value, value === 0);
                if (activatePage === 0) {
                    setOnboardingShow(true);
                }
            })
        }
        handleOnboarding();
    }); 

    const handleOnboarding = () => {
        console.log(getLocalstorage('onborading'));
        if (getLocalstorage('onborading')) {
            setOnboardingShow(false);
        }
        if (getLocalstorage('onborading') == null) {
            setOnboardingShow(true);
        }
        if (!getLocalstorage('onborading')) {
            setLocalstorage('onborading', true);
            setOnboardingShow(true);
        }

    }
    const getData = () => {
        let id = location.state.id;//params.filledID;
        getSelectedPatientData(id, data => {
            if (data) {
                if (data.error) {
                    if (data.type === 'REDIRECTLOGIN') {

                        EventEmitter.dispatch("loginChanged", "false");
                        clearLocalStrorage();
                        navigate('Login', { replace: true });
                    }
                } else {
                    setAnalysisData(data.message);
                }
            }
        });
    }


    return (
        <ShepherdTour steps={newSteps} tourOptions={tourOptions}>
            {onboardingShow &&
                <TourMethods>
                    {tourContext => <Start startTour={tourContext} />}
                </TourMethods>
            }
            <Box sx={{ width: '100%', bgcolor: 'background.paper' }} className="animate__animated animate__fadeIn" >
                <Tabs value={value} onChange={handleChange} className="tb-col pt-4 bg-gray-600 bg-gradient-to-t from-gray-800 fixed z-10 left-4 top-16 w-full left-0 px-2  animate__animated animate__fadeIn" style={styleClasses.tab}
                    textColor="inherit"
                    sx={{ background: '#eeeeee', paddingTop: '5px' }}
                    TabIndicatorProps={{ style: { background: '#1b2a47' } }}
                >
                    <Tab icon={<AnalyticsIcon />} iconPosition="start" style={styleClasses.tab} label="Analyze" className="check-analyze" />
                    <Tab icon={<FeedIcon />} iconPosition="start" style={styleClasses.tab} label="Patient Details" className="check-patient" />
                    <Tab icon={<SummarizeIcon />} iconPosition="start" style={styleClasses.tab} label="Report" className="check-report" />
                    <Tab icon={<AccessibilityIcon />} iconPosition="start" style={styleClasses.tab} label="Pain sensitivity" className="check-report" />
                    {/* <Tab icon={<RateReviewIcon />} iconPosition="start" style={styleClasses.tab} label="Pain sensitivity Result" className="check-report" /> */}
                    {analysisData?.spinaAnalysis?.exclusionText &&
                        <div className="right-0 absolute align-middle  bg-blue-100 px-2 py-3  top-0  border-l border-gray-300 shadow-lg">
                            <small className=" text-gray-800  block  mb-0 ">This patient is excluded because: </small>
                            <span className="block  text-sm  text-blue-900" >{analysisData.spinaAnalysis.exclusionText} </span>
                        </div>}
                </Tabs>
                {
                    value === 0 &&
                    <Dcm value={value} patientAnalysis={analysisData} state={location} parentCallbackToTabs={handleChangeTabs}></Dcm>
                }
                {
                    value === 1 &&
                    <PatientInfo value={value} state={location}></PatientInfo>
                }
                {
                    value === 2 &&
                    <Report value={value} patientAnalysis={analysisData} >
                    </Report>
                }
                {
                    value === 3 &&
                    < PainSensitivityTab value={value} patientAnalysis={analysisData} state={location} parentCallbackToTabs={handleChangeTabs}>
                    </PainSensitivityTab>
                }
                {
                    value === 4 &&
                    <PainSensitivityResult value={value} patientAnalysis={analysisData} state={location} parentCallbackToTabs={handleChangeTabs}>
                    </PainSensitivityResult>
                }
            </Box>
        </ShepherdTour>
    );
}

export default ViewerTabs;
